import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const BillsLabelCircledIcon = forwardRef(
  ({ size = 40, className = '', ...props }, ref) => (
    <svg
      {...props}
      className={className}
      ref={ref}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill={Colors.tertiary} />
      <circle
        cx="20"
        cy="19.9995"
        r="12.3913"
        stroke={Colors.dark}
        strokeWidth="1.30435"
      />
      <path
        d="M19.7183 24.996C20.723 24.996 21.5718 24.7477 22.2647 24.2512C22.9575 23.7425 23.4599 23.0643 23.7717 22.2166H25.4346C25.0651 23.5488 24.3953 24.6024 23.4252 25.3775C22.4552 26.1405 21.2253 26.522 19.7356 26.522C18.3152 26.522 17.1027 26.1042 16.098 25.2685C15.0933 24.4207 14.4351 23.2884 14.1233 21.8714H12.3911V21.0176H13.9674C13.9328 20.6906 13.9155 20.3575 13.9155 20.0184C13.9155 19.8246 13.927 19.5461 13.9501 19.1828H12.3911V18.3289H14.0713C14.2677 17.3601 14.6257 16.5123 15.1453 15.7856C15.665 15.0469 16.3174 14.4777 17.1027 14.078C17.8995 13.6783 18.7772 13.4785 19.7356 13.4785C21.2253 13.4785 22.4552 13.8661 23.4252 14.6412C24.3953 15.4042 25.0651 16.4517 25.4346 17.784H23.7717C23.4599 16.9362 22.9575 16.264 22.2647 15.7675C21.5718 15.2588 20.723 15.0045 19.7183 15.0045C18.7598 15.0045 17.9226 15.3012 17.2066 15.8946C16.4907 16.476 16.0056 17.2874 15.7516 18.3289H19.9782V19.1828H15.5957C15.561 19.4492 15.5437 19.7278 15.5437 20.0184C15.5437 20.406 15.5668 20.739 15.613 21.0176H19.9782V21.8714H15.7862C16.0749 22.8524 16.5657 23.6214 17.2586 24.1785C17.963 24.7235 18.7829 24.996 19.7183 24.996Z"
        fill={Colors.dark}
      />
    </svg>
  )
);

BillsLabelCircledIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
};

export default BillsLabelCircledIcon;
